/**
 * Check buttons list component script
 */
export const ContactsChooser = (function () {
  var init = function () {
    /**
     * Setup each component of this type on the page - FYI they are 'key' based because potentially there can be more than one, 
     * and keys stop them conflicting
     */
    $(".contacts-chooser-list-items.populate-me").each(function () {
      var key = $(this).attr("data-attr-key");
      populateTableKey(key);
    });
  };


  /**
   * Un-select any selected contacts in the component. Used when for example you're editing a new record after
   * previously using the form, and need to choose a new set of 'chosen contacts'
   */
  var clearSelectedContacts = function (key) {
    $(
      '.contacts-chooser-container[data-attr-key="' + key + '"] .input-contacts'
    ).val("");
    $('.btn-life-people[data-attr-key="' + key + '"]')
      .removeClass("btn-primary")
      .addClass("btn-outline")
      .removeClass("is-selected")
      .parent().parent().addClass("d-none");
  };

  /**
   * Programmatically set a 'chosen contacts' - ie, when editing a record
   */
  var setSelectedContact = function (key, contactId) {
    var elem = $('.btn-life-people[data-attr-item-key="' + contactId + '"]');
    $(elem)
      .removeClass("btn-outline")
      .addClass("btn-primary")
      .addClass("is-selected")
      .parent().parent().removeClass("d-none");

    var selectContactsInput = $(
      '.contacts-chooser-container[data-attr-key="' + key + '"] .input-contacts'
    );
    var existingValue = $(selectContactsInput).val();
    $(selectContactsInput).val(existingValue + "," + contactId + ",");

    //move it to the top of the list
    $(elem)
      .parent()
      .parent()
      .prependTo(".contacts-chooser-list-items[data-attr-key='" + key + "']");
  };

  /**
   * Init listeners on the search inputs for the specified component, and filter records accordingly on user input
   */
  var initContactSearch = function (key) {
    $(".contacts-search")
      .off("keyup")
      .on("keyup", function () {
        var parentElem = $(this).closest(
          ".support-package-container[data-attr-key='" + key + "']"
        );

        var searchValue = $(this).val();
        var searchValueLength = searchValue.length;

        if (searchValueLength < 1) {
          $(parentElem).find(".person-click-row").addClass("d-none");
          return;
        }

        $(parentElem).find(".person-click-row").addClass("d-none");

        $(parentElem)
          .find(".person-click-row .btn-life-people")
          .each(function () {
            var currentRecord = $(this).html();

            if (
              currentRecord.toLowerCase().includes(searchValue.toLowerCase())
            ) {
              $(this).closest(".person-click-row").removeClass("d-none");
            } else {
              $(this).closest(".person-click-row").addClass("d-none");
            }
          });
      });
  };

  /**
   * Load the table data for the specified component
   */
  var populateTableKey = function (key) {
    $.get(
      MaMFormHandler.getBaseUrl() +
        "/get-table/contact?key=" +
        key +
        "&records=all",
      function (res) {
        $("#contactsChooserContainer-" + key + " .person-click-row").remove();

        $.each(res, function (i, val) {
          if (val.contact_type == "organisation") {
            var buttonTitle = val.organisation_name;
            var contactType = "contact";
          } else {
            var buttonTitle = val.first_name + " " + val.surname;
            var contactType = "people";
            return; //organisations only at the moment
          }

          $('.contacts-chooser-list-items[data-attr-key="' + key + '"]').append(
            '<div class="col-md-4 person-click-row d-none">' +
              '<div class="form-group">' +
              '<button type="button" class="btn btn-outline btn-life-people" data-toggle="modal" data-attr-key="' +
              key +
              '" data-attr-item-key="' +
              val.id +
              '"' +
              'data-target="#myPeopleModal-' +
              key +
              '"' +
              'data-attr-mode="' +
              contactType +
              '">' +
              buttonTitle +
              "</button>" +
              "</div>" +
              "</div>"
          );
          $(
            '.contacts-chooser-list-items[data-attr-key="' + key + '"]'
          ).removeClass("populate-me");
        });
        regSelectClicks();
        initContactSearch(key);
      },
      "json"
    );
  };

  /**
   * Set the person/contact as 'selected' - populating their ID into an array
   */
  var regSelectClicks = function () {
    //edit-open mode
    $("button.btn-life-people")
      .off("click")
      .on("click", function () {
        var key = $(this).attr("data-attr-key");
        var selectContactsInput = $(
          '.contacts-chooser-container[data-attr-key="' +
            key +
            '"] .input-contacts'
        );
        var existingValue = $(selectContactsInput).val();

        if ($(this).hasClass("is-selected")) {
          $(this)
            .removeClass("btn-primary")
            .addClass("btn-outline")
            .removeClass("is-selected");
          var newValue = $(selectContactsInput)
            .val()
            .replace("," + $(this).attr("data-attr-item-key") + ",", "");
          $(selectContactsInput).val(newValue);
        } else {
          $(this)
            .removeClass("btn-outline")
            .addClass("btn-primary")
            .addClass("is-selected");
          $(selectContactsInput).val(
            existingValue + "," + $(this).attr("data-attr-item-key") + ","
          );
        }
      });
  };

  return {
    init: init,
    clearSelectedContacts: clearSelectedContacts,
    setSelectedContact: setSelectedContact,
  };
})();
